module.exports = {
      id: "authoruser-usage",
      viewBox: "0 0 250 250",
      url: __webpack_public_path__ + "svg-sprite-fa9bd75c1e834befd19aa957a85e34e1.svg#authoruser",
      toString: function () {
        return this.url;
      }
    }